module.exports = __webpack_public_path__ + "img/japan-tuberculosis-male.c103ca63.png";